import { MaskLines, Reveal } from "@/components/Reveal";

export const PageHero = ({ kicker, lines, accentIndex = -1, description }) => (
  <section className="grain relative overflow-hidden bg-roch-navy pb-20 pt-40 sm:pb-28 sm:pt-48">
    <div
      className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-roch-royal/30 blur-[120px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal y={16}>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-roch-orange">{kicker}</p>
      </Reveal>
      <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <MaskLines
          delay={0.15}
          lines={lines.map((line, i) => (
            <span key={i} className={i === accentIndex ? "text-roch-orange" : undefined}>
              {line}
            </span>
          ))}
        />
      </h1>
      {description && (
        <Reveal delay={0.5}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg">{description}</p>
        </Reveal>
      )}
    </div>
  </section>
);
